import { styled } from '@linaria/react';
import { colors, fonts, layout } from '../../theme/tokens';

export const StyledInput = styled.input<{ $variant: 'borderless' | 'outlined'; $error?: boolean }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
  padding: ${layout.inputPadding};
  border: ${(p) =>
    p.$variant === 'outlined'
      ? `1px solid ${p.$error ? colors.error : colors.borderGrey}`
      : 'none'};
  border-radius: ${(p) => (p.$variant === 'outlined' ? layout.borderRadiusMd : '0')};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  background: transparent;

  &::placeholder {
    color: ${colors.grey};
  }

  &:focus {
    background: ${(p) => (p.$variant === 'borderless' ? colors.lighterGrey : 'transparent')};
    border-color: ${(p) => (p.$variant === 'outlined' ? colors.primary : 'transparent')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[aria-invalid='true'] {
    border-color: ${(p) => (p.$variant === 'outlined' ? colors.error : 'transparent')};
  }
`;
